module.exports = __webpack_public_path__ + "img/active_arrow_right.07b52b3c.svg";